<template>
  <v-container fluid class="max-width">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Project Requisition</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" small text to="/requisitions-approval">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="subtitle-2 text--primary style-14">
          <v-col cols="12" md="3">
            <span class="style-18" style="color: #FF5733">Phase: {{ phase }}</span>
          </v-col>

          <v-col cols="12" md="9">
            <!-- <v-btn class="float-right" color="accent" text @click="generatePdf">
              <v-icon left>mdi-file-pdf-box</v-icon>Generate Requisition
            </v-btn>-->

            <v-btn color="primary" class="float-right" @click="approvalModal">
              <v-icon left>mdi-check</v-icon>Approve Requisition
            </v-btn>
            <!-- <iframe :src="pdfUrl" width="100%" height="500px"></iframe> -->
          </v-col>
          <v-col cols="12">
            <v-row dense class="pa-1">
              <v-col cols="6">Title:</v-col>
              <v-col cols="6">{{ project.name}}</v-col>

              <v-col cols="6">
                <span>Scale:</span>
              </v-col>
              <v-col cols="6">
                <span style>{{ project.projectScale && project.projectScale.Name }}</span>
              </v-col>

              <v-col cols="6">Project Lead:</v-col>
              <v-col cols="6">{{ project.lead && project.lead.name }}</v-col>

              <v-col cols="6">Start Date:</v-col>
              <v-col cols="6">{{ project.startDate | date }}</v-col>

              <v-col cols="6">Start Time</v-col>
              <v-col cols="6">{{ project.startTime }}</v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-divider class="mt-4 mb-2"></v-divider>

        <v-row class="mt-2 subtitle-2 text--primary">
          <v-col cols="12" v-for="(consumable, i) in projectConsumables" v-bind:key="i">
            <v-toolbar color="secondary" flat dense>
              <v-toolbar-title>{{ consumable.categoryName}}</v-toolbar-title>
            </v-toolbar>

            <v-data-table
              :items-per-page="2000"
              :headers="headers"
              :items="consumable.projectConsumables"
              hide-default-footer
            >
              <!-- total template -->
              <template
                v-slot:item.total="{ item }"
              >{{ (item.quantity * item.price).toLocaleString() }}</template>
              <!-- end -->
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!--  delete dialog -->
    <v-dialog v-model="approvalDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="secondary" flat>
          <v-toolbar-title>Approve Requisition</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="approvalDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="6">
                <span class="style-18">Project: {{ project && project.name }} - Phase: {{ phase }}</span>
              </v-col>

              <v-col cols="12">
                <v-btn color="primary" :loading="loader" @click="approveRequisition">
                  <v-icon left>mdi-check</v-icon>Approve
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of delete  modal-->

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>
  
  <script>
import { http, host } from "@/common/index";
export default {
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
    TotalBill() {
      var qty = 0;

      if (this.record.Quantity) {
        qty = this.record.Quantity;
      }

      return qty * this.BuyingPrice;
    }
  },
  data: () => ({
    pdfUrl: "",
    approvalDialog: false,
    selectedPhase: null,
    phase: null,
    loader: false,
    phases: [
      { name: "Phase 1", value: 1 },
      { name: "Phase 2", value: 2 },
      { name: "Phase 3", value: 3 },
      { name: "Phase 4", value: 4 }
    ],
    record: {},
    project: {},
    consumableCategories: [],
    projectConsumables: [],
    products: [],
    docCreate: true,
    headers: [
      { text: "Product", value: "product.Name" },
      { text: "Qty", value: "quantity" },
      { text: "Price", value: "price" },
      { text: "Total", value: "total" },
      { text: "Phase", value: "phase" }
    ]
  }),
  watch: {
    "$route.params.projectId": {
      handler: "fetchPhaseConsumables",
      immediate: true
    }
  },
  methods: {
    approveRequisition() {
      const self = this;
      const projectId = this.$route.params.projectId;
      const phase = this.$route.params.phase;
      var url = `/approve-requisition/${projectId}/${phase}`;
      self.loader = true;
      this.$store
        .dispatch("post", { url: url, data: {} })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$refs.snackbar.show(res.msg, "green");
            self.loader = false;
           self.$router.push("/approved-requisitions");
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    approvalModal() {
      this.approvalDialog = true;
    },
    fetchPhaseConsumables(projectId) {
      const self = this;
      const phase = this.$route.params.phase;
      this.$store
        .dispatch("get", `/project-consumables-phase/${projectId}/${phase}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.projectConsumables = res.ResponseData.consumables;
            self.project = res.ResponseData.project;
            self.phase = res.ResponseData.phase;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    generatePdf() {
      var url = "/generate-pdf";
      const apiUrl = `${host}${url}`;
      http.get(apiUrl, { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        this.pdfUrl = URL.createObjectURL(blob);
      });
    }
  },
  created() {}
};
</script>